"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoicePaymentInfoTemplateEnum = void 0;
var InvoicePaymentInfoTemplateEnum;
(function (InvoicePaymentInfoTemplateEnum) {
    InvoicePaymentInfoTemplateEnum["HANDELSBANKEN_BG_SEK"] = "HANDELSBANKEN_BG_SEK";
    InvoicePaymentInfoTemplateEnum["HANDELSBANKEN_IBAN_SEK"] = "HANDELSBANKEN_IBAN_SEK";
    InvoicePaymentInfoTemplateEnum["HANDELSBANKEN_IBAN_EUR"] = "HANDELSBANKEN_IBAN_EUR";
    InvoicePaymentInfoTemplateEnum["HANDELSBANKEN_IBAN_USD"] = "HANDELSBANKEN_IBAN_USD";
    InvoicePaymentInfoTemplateEnum["WIZE_EUR"] = "WIZE_EUR";
})(InvoicePaymentInfoTemplateEnum = exports.InvoicePaymentInfoTemplateEnum || (exports.InvoicePaymentInfoTemplateEnum = {}));
